import { AcuityCensusRecord } from 'src/shared/models/acuity-census-record.model';
import { AcuityCategory } from 'src/shared/models/acuity-category.model';
import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
  })
export class AcuityUtility {
    
    public getCensusTotal(values: any, shiftRecordId: number, acuityCategories: AcuityCategory[], acuityCensusRecords: AcuityCensusRecord[]): number {
        let censusTotal = 0;

        acuityCategories.forEach(acuityCategory => {
            censusTotal += +values[this.getAcuityControlName(acuityCategory.id)];

            let record: AcuityCensusRecord;

            if (!acuityCensusRecords.some(a => a.acuityCategoryId == acuityCategory.id)) {
                record = new AcuityCensusRecord();

                record.acuityCategoryId = acuityCategory.id;                
                record.shiftRecordId = shiftRecordId;
                
                acuityCensusRecords.push(record);
            }
            else {
                record = acuityCensusRecords.find(a => a.acuityCategoryId == acuityCategory.id);
            }

            record.patients = +values[this.getAcuityControlName(acuityCategory.id)];
        });

        return censusTotal;
    }

    public getAcuityControlName(acuityId: number): string {
        return 'acuity' + acuityId;
    }
    
    public valueOutOfRange(acuityCategoryId: number, acuityForm: UntypedFormGroup) : boolean {
        let control = acuityForm.get(this.getAcuityControlName(acuityCategoryId));
        return control && !control.valid && (control.touched || control.dirty) && (control.errors && control.errors.min);
    }
}